import { get } from 'lodash';

function parseReasonList(unparsedReasons) {
  const groups = [];
  const reasons = [];
  Object.keys(unparsedReasons).forEach(groupName => {
    if (!groupName) {
      return;
    }

    groups.push({
      title: groupName,
      value: groupName,
    });

    unparsedReasons[groupName].forEach(reason => {
      const title = get(reason, 'reason') || '';
      reasons.push({
        title,
        value: String(get(reason, 'id')) || title,
        groupId: groupName,
      });
    });
  });

  return { groups, reasons };
}

export const parseSegments = ({ segments: unparsedSegments }) =>
  unparsedSegments.map(segment => {
    const title = get(segment, 'segment') || '';
    return {
      title,
      value: String(segment.id) || title,
    };
  });

export const parseReasons = ({
  reasons: unparsedReasons,
  required_note_ids: requireNoteIds,
}) => {
  const incomingReasons = get(unparsedReasons, 'incoming', {});
  const outgoingReasons = get(unparsedReasons, 'outgoing', {});

  return {
    requireNoteIds,
    reasons: {
      incoming: parseReasonList(incomingReasons),
      outgoing: parseReasonList(outgoingReasons),
    },
  };
};
